/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import CSSModules from 'react-css-modules';

import {
  POST_COMMENTS,
} from '../../constants/strings';

import SectionTitle from '../Community/SectionTitle';
import Comment from '../Comment';

import styles from './index.styl';

const Comments = ({
  intl: { formatMessage },
  list,
  total,
  onReply,
  getCommentDeleteHandler,
  getCommentEditHandler,
  onRequestConversation,
  loggedUserId,
  canComment,
}) => {
  const commentsCount = total || 0;
  const title = `${formatMessage(POST_COMMENTS)} (${commentsCount})`;

  return (
    <div styleName="comments">
      <SectionTitle text={title} />
      <ul styleName="comments__list">
        {list.map((comment, i) => (
          <li key={i} className="mt1">
            <Comment
              {...comment}
              getCommentDeleteHandler={getCommentDeleteHandler}
              getCommentEditHandler={getCommentEditHandler}
              onReply={content => onReply({ content, parentId: comment.id })}
              onRequestConversation={onRequestConversation}
              loggedUserId={loggedUserId}
              canComment={canComment}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

Comments.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }),
  list: PropTypes.array, // todo
  onReply: PropTypes.func,
  total: PropTypes.number,
  getCommentDeleteHandler: PropTypes.func,
  getCommentEditHandler: PropTypes.func,
  onRequestConversation: PropTypes.func,
  loggedUserId: PropTypes.number,
  canComment: PropTypes.bool,
};

export default injectIntl(CSSModules(Comments, styles, { allowMultiple: true }));



// WEBPACK FOOTER //
// ./src/components/Post/Comments.jsx